<button uilab-mat-button (click)="toggleTheme()">
    <uilab-mat-icon svgIcon="view--theme_outlined"></uilab-mat-icon>
    {{ getThemeToggleLabel() }}
</button>
